<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      emp_sectors: [],
      EmpSectors: {},
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchModel: "",
      searchEmpSectors: null,
      EmpSectorsSearchMode: false,
      // appprices:[]
    };
  },
  methods: {
    addEmpSectors() {
      var data = {
        title: "popups.addsectors",
        inputs: [{ model: "name", type: "text", label: "popups.name" }],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("emp-sectors", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    EditEmpSectors(app) {
      var data = {
        title: "popups.editsectors",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "popups.name",
            value: app.name,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("emp-sectors/", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.EmpSectorsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("emp-sectors/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          this.emp_sectors = res.data;
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.EmpSectorsSearchMode = false;
      this.get(this.page);
    },
    getEmpSectors() {
      this.http.get("emp-sectors").then((res) => {
        this.emp_sectors = res.data;
      });
    },
    deleteEmpSectors(app) {
      var data = {
        title: "popups.delsectors",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http.delete("emp-sectors", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("emp-sectors/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.emp_sectors = res.data;
        });
    },
  },
  created() {
    this.get(1);
    this.getEmpSectors();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.organization.subItems.employ-sector')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="EmpSectorsSearchMode"
          @click="cancelappsearchMode()"
        ></button>

        <button
          type="button"
          @click="addEmpSectors()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("emp_sectors.id") }}</th>
          <th scope="col">{{ $t("emp_sectors.name") }}</th>
          <th scope="col">{{ $t("emp_sectors.created") }}</th>
          <th scope="col">{{ $t("emp_sectors.updated") }}</th>
          <th scope="col">{{ $t("emp_sectors.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app, index) in emp_sectors" :key="app" class="text-center">
          <td>{{ index + 1 }}</td>
          <td>{{ app.name }}</td>
          <td>{{ app.created.split("T")[0] }}</td>
          <td>{{ app.updated.split("T")[0] }}</td>
          <td>
            <a
              class="btn btn-primary me-2"
              @click="EditEmpSectors(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger me-2"
              href="javascript: void(0);"
              role="button"
              @click="deleteEmpSectors(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <!--   Apps  Pagination     -->
    <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
